import React from 'react';
import icon from '../../../../assets/icons/charts/reporting/icon-reporting.svg';
import SVG from "react-inlinesvg";

const IconReporting = () => (
        <SVG src={icon} height={25} style = {{ marginRight: 10}} />
);
export default IconReporting;